import { v4 as uuid } from 'uuid';

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const CLOSE_MESSAGE = 'CLOSE_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';


export const addErrorMessage = (message) => {
  return {
    type: ADD_MESSAGE,
    payload: {
      key: uuid(),
      message: message,
      options: {
        variant: 'error',
      }
    },
  };
};

export const addSuccessMessage = (message) => {
  return {
    type: ADD_MESSAGE,
    payload: {
      key: uuid(),
      message: message,
      options: {
        variant: 'success',
      }
    },
  };
};

export const addMessage = (notification) => {
  return {
    type: ADD_MESSAGE,
    payload: {
      ...notification,
      key: uuid(),
    },
  };
};

export const closeMessage = key => ({
  type: CLOSE_MESSAGE,
  dismissAll: !key, // dismiss all if no key has been defined
  key,
});

export const removeMessage = key => ({
  type: REMOVE_MESSAGE,
  key,
});
